module.exports = "./assets/images/pic5.jpeg";